/**
 * /tenants/$slug/authentication/conditional-access/new — create route.
 */

import { createFileRoute } from "@tanstack/react-router";
import { PolicyEditorPage } from "@/features/policies/pages/policy-editor-page";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/conditional-access/new")({
  component: () => <PolicyEditorPage mode="create" />,
});
